import { makeAutoObservable } from 'mobx';

import { asSuccessPromise } from '^/types/__ResultType';
import { AppContext } from '^/userWeb/types/AppContext';
import { isDefined } from '^/utils';

export class RecentCowStanzoneSlidesViewModel {
  constructor(
    public appContext: AppContext,
  ) {
    makeAutoObservable(this, {
      appContext: false,
    });
  }

  get stanzoneStatsByCam() {
    const stanzoneHistoryByCamId = this
      .appContext
      .cowStanzoneListCore
      .getStanzoneHistoryByCamId({
        take: 10,
      });
    if (stanzoneHistoryByCamId.status !== 'success') {
      return stanzoneHistoryByCamId;
    }
    const a = stanzoneHistoryByCamId
      .value
      .entries()
      .map(([camId, hist], idx) => {
        const qwe = this
          .appContext
          .liveCamsRepo
          .getCamById(camId);
        const camName = qwe.status === 'success' ? qwe.value.name : `카메라${idx}_(${camId})`;
        const latestHist = hist.first();
        if (!latestHist) {
          return null;
        }
        if (latestHist.pushType === 'LOCKED_FOR_TOO_LONG') {
          return {
            status: 'LOCKED_FOR_TOO_LONG',
            startTime: latestHist.sameStatusSince,
            latestPushTime: latestHist.createdAt,
            latestHist,
            camId,
            camName,
          } as const;
        }
        if (latestHist.isUp === true) {
          return {
            status: 'LOCKED',
            camId,
            camName,
            latestHist,
          } as const;
        }
        return {
          status: 'UNLOCKED',
          camId,
          camName,
          latestHist,
        } as const;
      });
    const filtered = a
      .filter((v) => isDefined(v));
    return asSuccessPromise(filtered.toArray());
  }
}
